import { SCROLL_BAR_WIDTH } from 'src/utils/dom'

import { PARAGRAPH_METADATA_DESKTOP_MARGIN } from './TranscriptViewer/ParagraphView/constants'

export const TRANSCRIPT_FULL_WIDTH_PADDING = 24
export const MOBILE_PHONE_TEXT_HORIZONTAL_PADDING = 20

export const GREEN_CHROMAKEY_LOGO_WIDTH = 250
export const GREEN_CHROMAKEY_LOGO_GAP = 16

export const PARAGRAPH_LINE_HEIGHT_PROPORTION = 1.5
export const PARAGRAPH_VERTICAL_PADDING = 8

type GetTranscriptDimensionsParams = {
    isFullWidthMode: boolean
    containerWidth: number
    shouldDisplayLogo: boolean
}
type TranscriptDimensions = {
    transcriptParagraphWidth: number
    metadataWidth: number
}
export const getTranscriptDimensions = ({
    containerWidth,
    isFullWidthMode,
    shouldDisplayLogo,
}: GetTranscriptDimensionsParams): TranscriptDimensions => {
    const metadataFixedWidth = 60
    const metadataWidth = metadataFixedWidth + PARAGRAPH_METADATA_DESKTOP_MARGIN

    const transcriptParagraphFixedWidth = 880
    let transcriptParagraphWidth = isFullWidthMode
        ? containerWidth - SCROLL_BAR_WIDTH - TRANSCRIPT_FULL_WIDTH_PADDING * 2
        : transcriptParagraphFixedWidth

    if (shouldDisplayLogo) {
        transcriptParagraphWidth -= GREEN_CHROMAKEY_LOGO_WIDTH + GREEN_CHROMAKEY_LOGO_GAP
    }

    return { transcriptParagraphWidth, metadataWidth }
}

export const AUTO_SCROLL_THRESHOLD = 1500

export const AI_PANEL_MIN_MOBILE_PHONE_SIZE = 95
export const AI_PANEL_MIN_TABLET_SIZE = 50
export const AI_PANEL_MIN_DESKTOP_SIZE = 30
export const AI_PANEL_ENLARGED_SIZE = 50
export const AI_PANEL_SIZE_TRANSITION_MS = 320
/* react-resizable-panels keeps flex-basis and flex-shrink constant and carries the panel size in flex-grow */
export const AI_PANEL_SIZE_TRANSITION = `flex-grow ${AI_PANEL_SIZE_TRANSITION_MS}ms ease-in-out`
export const AI_PANEL_SIZE_TRANSITION_CLASSNAME = 'ai-panel-size-transition'
export const PREFERS_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

export const TRANSCRIPT_VIEWER_MIN_WIDTH = 660
export const TRANSCRIPT_PANEL_MIN_WIDTH = '320px'
